/**
 * The brand gradient behind full-screen standalone pages (sign-in, OAuth,
 * Telegram connect). The accent stops resolve from the --layout-gradient-*
 * tokens, which flip between light and dark values, so no `dark:` override
 * is needed.
 */
export const PAGE_GRADIENT_BACKGROUND =
  'bg-[radial-gradient(ellipse_at_50%_0%,var(--layout-gradient-primary)_0%,transparent_50%),radial-gradient(ellipse_at_80%_100%,var(--layout-gradient-info)_0%,transparent_40%),var(--background)]';
